import { Injectable } from '@angular/core';
import { ActivityStudentAnswers, InputAnswer } from '@tekman/onmat/models';
import { Category } from '@tekman/onmat/service/onmat';
import { EnvironmentService } from '@tekman/onmat/service/generic';

@Injectable()
export class TekareaService {
  category: typeof Category = Category;

  constructor(
    private readonly env: EnvironmentService,
  ) {}

  parseTekarea(htmlStatement: string, isTeacher: boolean, studentAnswers: ActivityStudentAnswers, isValidated: boolean, categoryId?): string {
    return htmlStatement.replace(/(<tek_area.*?>)(.*?)(<\/tek_area.*?>)/g, tekarea =>
      this.tekAreaReplacer(isTeacher, studentAnswers?.inputs, isValidated, tekarea, categoryId)
    );
  }

  private tekAreaReplacer(isTeacher: boolean, inputAnswer: InputAnswer[], isValidated: boolean, tekarea: string, categoryId?): string {
    const orderTekarea = +tekarea.match(/(order=".*?")/g)[0].split('"')[1];
    const tekAreaAnswer = inputAnswer?.find(input => Number(input.order) === orderTekarea);
    const isDisabled = (isTeacher || categoryId == this.category.ACTIVIDADES) ? true : isValidated;
    const attributes = [
      `[validated]="${isValidated}"`,
      `[disabled]="${isDisabled}"`,
      `[isTeacher]="${isTeacher}"`,
      `categoryId="${categoryId}"`,
      tekarea.substring(tekarea.indexOf('<tek_area') + 10, tekarea.lastIndexOf('></tek_area>')),
    ];
    if (tekAreaAnswer) {
      attributes.push(`value="${this.getValue(tekAreaAnswer)}"`);
    }

    attributes.unshift('<tekarea');
    attributes.push('></tekarea>');

    return attributes.join(' ');
  }

  private getValue(answer: InputAnswer): string {
    return answer && answer.value !== null && answer.value !== 'null' ? answer.value : '';
  }
}
